import { ServiceType, ServiceAction } from '../types/service.type';

interface ServiceTypeConfig {
  icon: string;
  color: string;
  bgColor: string;
  borderColor: string;
  label: string;
  labelPlural: string;
  defaultActions: ServiceAction[];
  hasVisitUrl: boolean;
  hasAdminUrl: boolean;
}

export const SERVICE_TYPE_CONFIG: Record<ServiceType, ServiceTypeConfig> = {
  wordpress: {
    icon: '🔷',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    label: 'WordPress',
    labelPlural: 'WordPress Sites',
    defaultActions: ['visit', 'admin', 'restart', 'stop', 'delete'],
    hasVisitUrl: true,
    hasAdminUrl: true,
  },
  database: {
    icon: '🗄️',
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    label: 'Database',
    labelPlural: 'Databases',
    defaultActions: ['settings', 'restart', 'stop', 'backup', 'delete'],
    hasVisitUrl: false,
    hasAdminUrl: false,
  },
  vm: {
    icon: '💻',
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    label: 'Virtual Machine',
    labelPlural: 'Virtual Machines',
    defaultActions: ['visit', 'restart', 'stop', 'settings', 'delete'],
    hasVisitUrl: true,
    hasAdminUrl: false,
  },
  storage: {
    icon: '📦',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    label: 'Storage',
    labelPlural: 'Storage Buckets',
    defaultActions: ['settings', 'backup', 'delete'],
    hasVisitUrl: false,
    hasAdminUrl: false,
  },
  cdn: {
    icon: '🌐',
    color: 'text-cyan-600',
    bgColor: 'bg-cyan-50',
    borderColor: 'border-cyan-200',
    label: 'CDN',
    labelPlural: 'CDN Distributions',
    defaultActions: ['settings', 'metrics', 'delete'],
    hasVisitUrl: true,
    hasAdminUrl: false,
  },
  app_deploy: {
    icon: '🚀',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    borderColor: 'border-indigo-200',
    label: 'Deploy App',
    labelPlural: 'Deploy Apps',
    defaultActions: ['visit', 'logs', 'restart', 'stop', 'delete'],
    hasVisitUrl: true,
    hasAdminUrl: false,
  },
  APP_DEPLOY: {
    icon: '🚀',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    borderColor: 'border-indigo-200',
    label: 'Deploy App',
    labelPlural: 'Deploy Apps',
    defaultActions: ['visit', 'logs', 'restart', 'stop', 'delete'],
    hasVisitUrl: true,
    hasAdminUrl: false,
  },
};

export const getServiceConfig = (type: ServiceType) => {
  return SERVICE_TYPE_CONFIG[type];
};